import { sr as reactsr } from '@ews/react-translations';

const sr = {
...reactsr
}
export default sr
